import React, { lazy } from 'react';

const UserListing = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/SystemAdminModule/AccessSecurityModule/UserModule/UserListing'
  ).then(module => ({
    default: module.UserListing,
  })),
);
const UserDetail = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/SystemAdminModule/AccessSecurityModule/UserModule/UserDetail'
  ).then(module => ({
    default: module.UserDetail,
  })),
);

const UserForm = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/SystemAdminModule/AccessSecurityModule/UserModule/UserForm'
  ).then(module => ({
    default: module.UserForm,
  })),
);

const UserCompanyAssignment = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/SystemAdminModule/AccessSecurityModule/UserModule/UserCompanyAssignment/UserCompanyAssignmentMain'
  ).then(module => ({
    default: module.UserCompanyAssignmentMain,
  })),
);

export const userRoutes = [
  //USERLIST
  {
    props: {
      exact: true,
      path: '/access-security/user',
    },
    component: <UserListing software="Contract" />,
  },
  //USER Detail
  {
    props: {
      exact: true,
      path: '/access-security/user/detail/:userID',
    },
    component: <UserDetail software="Contract" />,
  },

  {
    props: {
      exact: true,
      path: '/access-security/user/add',
    },
    component: <UserForm mode={'add'} software="Contract" />,
  },

  {
    props: {
      exact: true,
      path: '/access-security/user/edit/:userID',
    },
    component: <UserForm mode={'edit'} software="Contract" />,
  },
  {
    props: {
      exact: true,
      path: '/access-security/user/:userID/assign',
    },
    component: <UserCompanyAssignment />,
  },
];
